<template>
    <div class="experience-list">
        <ul class="list">
            <li class="list-item" 
                v-for="(item, index) in itensList" :key="item.value"
                :style="{'border-color':colorsOptions[colors.theme][index], 'color': colorsOptions[colors.theme][index]}"
                @click="toggleColor(colorsOptions[index], index)">
                {{item.descricao}}
            </li>
        </ul>
    </div>
</template>
<script>
import Bus from '../../main.js'
export default {
    data(){
        return{
            colors:{},
            colorsOptions : {
                dark: ['#3effb6', '#70c3d5', '#975cb7', '#df45a6', '#ff509d'],
                light:['#32C069', '#5499e3', '#935ab3', '#df45a5', '#fa488b']
            },
            selected : false
        }
    },
    props : {
        itensList : {
            type : Array,
            required : true
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    methods: {
        defineColor(color){
            return `border-color : ${color}`
        },
        toggleColor(colorSelect, index){
            if(!this.selected){
                this.selected = true
                Bus.$emit('ableButton')
            }
            let listItens = document.querySelectorAll('.list-item')
            listItens.forEach(item => {
                item.style.backgroundColor = this.colors.theme == 'dark' ? '#001420' : '#fff'
                item.style.color = this.colors.theme == 'dark' ? '#fff' : '#000'
                item.style.borderColor = this.colors.theme == 'dark' ? '#001420' : '#fff'
            })
            listItens[index].style.backgroundColor = this.colorsOptions[this.colors.theme][index]
            listItens[index].style.borderColor = this.colorsOptions[this.colors.theme][index]
            listItens[index].style.color = this.colors.theme == 'dark' ? '#000' : '#fff'
            this.$store.dispatch('callSetFeedback', { itemName : 'experience', itemData : this.itensList[index].value})
        }
    }
}
</script>
<style lang="scss" scoped>
    .experience-list{
        .list{
            .list-item{
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                text-transform: uppercase;
                font-weight: 900;
                letter-spacing: 2px;
                font-size: 12px;
                margin : 3% auto;
                width: 90%;
                cursor: pointer;
                max-width: 400px;
                border-radius: 300px;
                border: 2px solid;
            }
        }
    }
</style>
